<template>
  <div
    class="modal-mask"
    v-if="$store.getters.USERPROFILE['user-profile-administration']"
  >
    <section class="modal">

      <div class="content">
        <h1>{{$t('newProfile.title')}}</h1>
      </div>
      <hr>
      <div class="content">
        <p>{{$t('newProfile.selectAProfile')}}</p><br>
        <div class="row">
          <div class="column">
            <div v-for="info in checkboxInfoList1" :key="info.title" class="row">
              <label class="container">
                <input
                  type="checkbox"
                  v-model="profile[info.model]"
                />
                <span class="checkmark"></span><p style="padding-right: 25px;">{{info.value}}</p>
              </label>
              <br><br>
            </div>
          </div>
           <div class="column">
            <div v-for="info in checkboxInfoList2" :key="info.title" class="row">
              <label class="container">
                <input
                  type="checkbox"
                  v-model="profile[info.model]"
                />
                <span class="checkmark"></span>{{info.value}}
              </label>
              <br><br>
            </div>
          </div>
        </div>
        <br>
        <label>{{$t('newProfile.profileName')}}</label>
        <div class="demiRow">
          <input
            type="text"
            v-model="profile.name"
          />
        </div>
        <label>{{$t('newProfile.profileDescription')}}</label>
        <div class="demiRow">
          <input
            type="text"
            v-model="profile.description"
          />
        </div>
        <div class="row">
          <label class="container">
            <input
              type="checkbox"
              v-model="profile['default-profile']"
            />
            <span class="checkmark"></span>{{$t('newProfile.defaultProfile')}}
          </label>
        </div>
      </div>
      <hr>
      <div class="content">
        <div class="row">
          <button @click="addProfile()">{{$t('button.create')}}</button>
          <a @click="$emit('close')">{{$t('button.cancel')}}</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Profiles from "@/services/Profiles";
export default {
  data() {
    return {
      checkboxInfoList1: [
        {
          model: "user-administration",
          value: this.$t("newProfile.manageUsers")
        },
        {
          model: "all-campaigns-access",
          value: this.$t("newProfile.accessAllCampaign")
        },
        {
          model: "coupon-retrieval",
          value: this.$t("newProfile.assignCoupons")
        },
        {
          model: "coupon-export",
          value: this.$t("newProfile.exportCoupons")
        },
        {
          model: "campaign-follow-up",
          value: this.$t("newProfile.recapCampaign")
        }
      ],
      checkboxInfoList2: [
        {
          model: "campaign-administration",
          value: this.$t("newProfile.manageCampaign")
        },
        {
          model: "sales-channel-administration",
          value: this.$t("newProfile.manageSalesChannels")
        },
        {
          model: "product-administration",
          value: this.$t("newProfile.manageProducts")
        },
        { model: "user-invitation", value: this.$t("newProfile.inviteUser") },
        {
          model: "user-profile-administration",
          value: this.$t("newProfile.manageProfiles")
        }
      ],
      profile: {
        name: "",
        description: "",
        "default-profile": false,
        "user-administration": false,
        "all-campaigns-access": false,
        "coupon-retrieval": false,
        "coupon-export": false,
        "campaign-administration": false,
        "sales-channel-administration": false,
        "product-administration": false,
        "user-profile-administration": false,
        "user-invitation": false,
        "campaign-follow-up": false,
        archived: false
      },
      formStatus: {
        created: false
      }
    };
  },
  methods: {
    addProfile() {
      if (this.profile.name) {
        Profiles.add(this.profile).then(res => {
          if (res.status == 201) {
            this.profile = res.data;
            this.formStatus.created = true;
            this.$emit("get");
            this.$emit("close");
          }
        });
      }
    }
  }
};
</script>